import React from 'react';

type Props = {
	keys: {
		[id: string]: {
			type: string;
			text: string;
		}
	}
};

export const RenderMode: React.FC<Props> = ({ keys }) => (
	<pre>
		{`{`}
		{Object.entries(keys).map(([key, value]) => (
			<div className="ml-4">
				<b>{key}</b>{': '}
				{value.type}({value.text})
			</div>
		))}
		{`}`}
	</pre>
);
